import type { ElementKey } from '@/lib/experience'
import { ELEMENTS, ELEMENT_REVELATION } from '@/lib/experience'
import { motion } from 'framer-motion'
import ElementSigil from './ElementSigil'

interface Props {
  element: ElementKey
  onContinue: () => void
}

function StepRevelation({ element, onContinue }: Props) {
  const meta = ELEMENTS[element]
  const paragraphs = ELEMENT_REVELATION[element].split('\n\n')

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.9 }}
      className="w-full max-w-2xl mx-auto text-center"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        className="flex justify-center mb-6"
      >
        <ElementSigil element={element} size={112} />
      </motion.div>

      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.5 }}
        className="text-[11px] tracking-[0.35em] uppercase text-[var(--ink-soft)] font-body mb-3"
      >
        Seu elemento com mais bloqueios
      </motion.p>

      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="font-display type-hero leading-none mb-2"
        style={{ color: meta.accentSoft }}
      >
        <em className="italic font-light">{meta.label}</em>
      </motion.h1>

      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.9, delay: 1.1 }}
        className="h-px mx-auto mb-10 origin-center"
        style={{
          width: 120,
          background: `linear-gradient(90deg, transparent, ${meta.accentSoft}, transparent)`,
        }}
      />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.9, delay: 1.3 }}
        className="space-y-5 mb-12 text-left px-1"
      >
        {paragraphs.map((p, i) => (
          <p
            key={i}
            className={`font-body type-body ${
              i === 0 ? 'text-[var(--ink)]' : 'text-[var(--ink-soft)]'
            }`}
          >
            {p}
          </p>
        ))}
      </motion.div>

      <motion.button
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1.8 }}
        onClick={onContinue}
        className="btn-primary w-full sm:w-auto px-6 sm:px-10 py-5 min-h-[52px] type-button rounded-sm tracking-[0.12em] uppercase"
      >
        Reconhecer meu bloqueio principal
      </motion.button>
    </motion.div>
  )
}

export default StepRevelation
